var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{attrs:{"id":"toggle-switch"}},[_c('div',{staticClass:"video-conference"},[_c('span',{staticClass:"video-conference-text"},[_c('p',[_vm._v(_vm._s(_vm.selectedConfig.description))])])])])
}
var staticRenderFns = []

export { render, staticRenderFns }